import QuoteTypeSelect from './QuoteTypeSelect'
export default QuoteTypeSelect
